import { useDocumentBundleWizardStore } from '@repo/store/useDocumentBundleWizardStore'
import { useMattersStore } from '@repo/store/useMattersStore'

// Shared by the row actions menu and the clickable description cell so both
// trigger the exact same Edit Bundle wizard-opening logic.
export const editBundle = (navigate, bundleData: any) => {
  const { currentMatter } = useMattersStore.getState()

  useDocumentBundleWizardStore.getState().initialize({ mode: 'edit', selectedMatter: currentMatter, bundleData })

  navigate('?wizard=DocumentBundle&stage=create-bundle&step=create-document-bundle')
}
